<template>
  <div class="ltr">
    <div class="columns">
      <div class="column">
        <BaseInput v-model="min" label="Min Year ago" placeholder="Number of years ..." />
      </div>
      <div class="column">
        <BaseInput v-model="max" label="Max Year ago (optional)"  placeholder="Number of years ..." />
      </div>
    </div>
    <div class="modal_footer">
      <a @click="submit()" class="button is-info">Submit Filters</a>
      <div class="horizontal_space"></div>
      <a @click="clearFilter()" class="filter button is-danger">Clear Filters</a>
    </div>
  </div>
</template>
<script>
import BaseInput from '@/components/BaseInput'
export default {
  name: 'filters-input',
  props: ['payload'],
  data () {
    return {
      min: '',
      max: ''
    }
  },
  methods: {
    submit () {
      if (!this.max) {
        this.max = this.min
      }
      let query = { ...this.$route.query }
      query[this.payload.designator] = this.min ? `${this.min}|${this.max}` : undefined
      this.$router.push({ path: this.$route.path, query: query })
    },
    clearFilter () {
      this.min = undefined
      this.max = undefined
    }
  },
  components: {
    BaseInput
  }
}
</script>
